import { differenceInMilliseconds, isPast, parseISO } from 'date-fns'
import { millisecondsInDay } from 'date-fns/constants'

export const getDaysUntilExpiration = (expiresAt: string): number => {
  return Math.ceil(
    differenceInMilliseconds(parseISO(expiresAt), new Date()) /
      millisecondsInDay,
  )
}

export const isTokenExpired = (expiresAt: string): boolean => {
  return isPast(parseISO(expiresAt))
}

export const isTokenExpiringSoon = (expiresAt: string): boolean => {
  const days = getDaysUntilExpiration(expiresAt)
  return days <= 7 && days > 0
}
